import Button from "components/EvtKit/button/Button"
import Modal from "components/EvtKit/modal/Modal"
import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import AttentionIcon from "components/icons/AttentionIcon"
import { memo, useCallback } from "react"
import { useAppDispatch } from "reducers/store"
import { showToast } from "reducers/toast/toast-actions"
import styled from "styled-components"
import useWebhookRequest from "../hooks/useWebhookRequest"

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ButtonContent = styled.div`
  display: flex;
  width: 160px;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const ButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
`

interface WebhookIsPublishedModal {
  webhookData: App.IWebhook | null
  isOpen: boolean
  onClose: () => void
}

const WebhookIsPublishedModal: React.FC<WebhookIsPublishedModal> = (props: WebhookIsPublishedModal) => {
  const { webhookData, isOpen, onClose } = props

  const appDispatch = useAppDispatch()

  const onSuccess = useCallback(() => {
    appDispatch(showToast("Webhook atualizado com sucesso!"))
    onClose()
  }, [])

  const { onSubmit, isLoading } = useWebhookRequest("updateIsPublished", onSuccess, "Erro ao tentar atualizar Webhook")

  const handleSubmit = useCallback(() => {
    if (!webhookData) return
    onSubmit(webhookData)
  }, [onSubmit, webhookData?._id])

  return (
    <>
      <Modal openModal={isOpen} closeModal={onClose} size="1-lg">
        <ModalContent>
          <IconContainer>
            <AttentionIcon />
            <Heading color="informative" variant="h4">
              {webhookData?.isPublished ? "Despublicar Webhook" : "Republicar Webhook"}
            </Heading>
          </IconContainer>
          <Heading variant="h6">{webhookData?.name}</Heading>
          <BodyText color="gray-dark" size="medium" weight="light" className="fill-width">
            {webhookData?.isPublished && (
              <>
                A opção <b>'Não Publicado'</b> interrompe a utilização deste <b>Webhook</b> na plataforma. Os clientes
                que estiverem usando o endpoint <b>'{webhookData?.path}'</b> receberão erro ao executar as chamadas,
                prejudicando quaisquer usos existentes, mas você pode republicá-lo a qualquer momento, permitindo sua
                utilização novamente.
              </>
            )}
            {!webhookData?.isPublished && (
              <>
                A opção <b>'Publicado'</b> torna a utilização deste <b>Webhook</b> disponível na plataforma novamente,
                permitindo que os usuários possam voltar a usar o endpoint <b>'{webhookData?.path}'</b>.
              </>
            )}
          </BodyText>
          <BodyText size="medium" weight="bold">
            Tem certeza de que deseja continuar com esta ação?
          </BodyText>
          <ButtonContainer>
            <ButtonContent>
              <Button
                label="Sim"
                className={`fill-width secondary-attention`}
                onClick={handleSubmit}
                disabled={isLoading}
              />
            </ButtonContent>
            <ButtonContent>
              <Button label="Não" className={`fill-width attention-attention`} onClick={onClose} disabled={isLoading} />
            </ButtonContent>
          </ButtonContainer>
        </ModalContent>
      </Modal>
    </>
  )
}

export default memo(WebhookIsPublishedModal)
